/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teen_Setting_TitleInputs */

const fr_teen_setting_title = /** @type {(inputs: Teen_Setting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ados en cours adultes`)
};

/**

* @param {Teen_Setting_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teen_setting_title = /** @type {((inputs?: Teen_Setting_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teen_Setting_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teen_setting_title(inputs)
});